<template>
  <b-form
    id="privilege-category-information"
    @submit.prevent="createCategoryDetail"
  >
    <b-row class="category-information-form">
      <b-col cols="12">
        <b-card
          no-body
          class="mb-1 pb-4"
        >
          <b-card-header>
            <span class="information-header">Information</span>
          </b-card-header>
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div>
                        <span>{{ 'Status' }} </span>
                        <b-form-checkbox
                          v-model="categoryForm.status"
                          class="custom-control-success custom-toggle"
                          name="check-button"
                          switch
                        >
                          <span class="switch-icon-left toggle-text">{{
                            'Active'
                          }}</span>
                          <span class="switch-icon-right toggle-text">{{
                            'Inactive'
                          }}</span>
                        </b-form-checkbox>
                      </div>
                      <div class="row mt-2">
                        <div class="col-12">
                          <b-form-group
                            :label="'Reference'"
                            label-for="'Reference"
                            class=""
                          >
                            <b-form-input
                              id="Reference"
                              v-model="categoryForm.Reference"
                              disabled
                            />
                          </b-form-group>
                        </div>
                      </div>
                      <div />
                      <b-form-group
                        :label="'Category Name (En)'"
                        label-for="'name-en"
                        class="required"
                      >
                        <b-form-input
                          id="name-en"
                          v-model="categoryForm.nameEn"
                          required
                        />
                      </b-form-group>
                      <b-form-group
                        :label="'Category Name (Th)'"
                        label-for="'name-th"
                        class="required"
                      >
                        <b-form-input
                          id="name-en"
                          v-model="categoryForm.nameTh"
                          required
                        />
                      </b-form-group>
                      <!-- Valid Form/Valid Through Hide ไว้ก่อน ในอนาคตต้องมีตาม request -->
                      <!-- <b-row>
                        <b-col
                          cols="12"
                          class="mt-1"
                        >
                          <label
                            for="valid-from-date"
                            class="required"
                          >
                            Valid From
                          </label>
                          <div class="d-flex">
                            <div class="p-relative mr-1 article-date-picker">
                              <calendar-picker-icon
                                class="icon-calendar bypass"
                                :class="
                                  validFrom.date ? 'date-selected-icon' : null
                                "
                              />
                              <flat-pickr
                                :id="'valid-from-date'"
                                v-model="validFrom.date"
                                class="form-control bg-date"
                                :class="validFrom.date ? 'date-selected' : null"
                                :config="flatpickrDateConfig"
                                placeholder="Start Date"
                                required
                                autocomplete="off"
                                @on-open="onOpenValidFromDatePicker"
                                @on-change="onSelectValidFromDate"
                              />
                            </div>
                            <div class="p-relative article-date-picker">
                              <clock-picker-icon
                                class="icon-calendar date-picker-icon bypass"
                                :class="
                                  validFrom.time ? 'date-selected-icon' : null
                                "
                              />
                              <flat-pickr
                                id="valid-from-time"
                                v-model="validFrom.time"
                                class="form-control bg-date"
                                :class="validFrom.time ? 'date-selected' : null"
                                :config="flatpickrTimeConfig"
                                :placeholder="'HH : mm'"
                                required
                                autocomplete="off"
                                @on-open="onOpenValidFromTimePicker"
                                @on-change="onSelectValidFromTimePicker"
                              />
                            </div>
                          </div>
                        </b-col>
                        <b-col
                          cols="12"
                          class="mt-1"
                        >
                          <label
                            for="valid-from-to"
                            class="required"
                          >
                            Valid Through
                          </label>
                          <div class="d-flex">
                            <div class="p-relative mr-1 article-date-picker">
                              <calendar-picker-icon
                                class="icon-calendar bypass"
                                :class="
                                  validThrough.date
                                    ? 'date-selected-icon'
                                    : null
                                "
                              />
                              <flat-pickr
                                :id="'valid-to-date'"
                                v-model="validThrough.date"
                                class="form-control bg-date"
                                :class="
                                  validThrough.date ? 'date-selected' : null
                                "
                                :config="flatpickrDateConfig"
                                placeholder="End Date"
                                required
                                autocomplete="off"
                              />
                            </div>
                            <div class="p-relative article-date-picker">
                              <clock-picker-icon
                                class="icon-calendar date-picker-icon bypass"
                                :class="
                                  validThrough.time
                                    ? 'date-selected-icon'
                                    : null
                                "
                              />
                              <flat-pickr
                                id="valid-from-time"
                                v-model="validThrough.time"
                                class="form-control bg-date"
                                :class="
                                  validThrough.time ? 'date-selected' : null
                                "
                                :config="flatpickrTimeConfig"
                                :placeholder="'HH : mm'"
                                required
                                autocomplete="off"
                                @on-open="onOpenValidThroughTimePicker"
                              />
                            </div>
                          </div>
                        </b-col>
                      </b-row> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card
          no-body
          class="mb-1 pb-4"
        >
          <b-card-header>
            <span class="information-header">Icon or Image</span>
          </b-card-header>
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col-md-6 mb-2">
                  <label for="icon-image">
                    <span class="information-detail">{{ 'Icon/Image' }}</span>
                  </label>
                  <image-uploader
                    :image-url="categoryForm.image.url"
                    @onUpload="onUploadImage"
                  />
                </div>
                <div class="col-md-6">
                  <label for="sub-icon-image">
                    <span class="information-detail">{{
                      'Sub Icon/Image'
                    }}</span>
                  </label>
                  <image-uploader
                    :image-url="categoryForm.imageSub.url"
                    @onUpload="onUploadImageSub"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card
          no-body
          class="mb-1 pb-4"
        >
          <b-card-header>
            <span class="information-header">Tags</span>
          </b-card-header>
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <v-select
                        id="category-tier-option"
                        v-model="categoryForm.tag"
                        multiple
                        :options="optionData.tagList.payload"
                        class="tag-dropdown"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <div class="privilege-btn-wrp mt-2 mb-2">
      <div class="d-flex justify-content-center">
        <cancel-button
          class="mr-1"
          @click.native="$router.push('/privilege/category')"
        />
        <save-button
          type="submit"
          class="ml-1"
          :btn-label="'Save'"
          :loading="loading"
        />
      </div>
    </div>
  </b-form>
</template>

<script>
import ImageUploader from '@core/components/image-uploader/ImageUploader.vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import CalendarPickerIcon from '@/@core/components/svg/common/CalendarPicker.vue'
import ClockPickerIcon from '@/@core/components/svg/common/ClockPicker.vue'
import usePrivilegeCategoryInfo from '../hooks/usePrivilegeCategoryInfo'

export default {
  components: {
    ImageUploader,
    flatPickr,
    vSelect,
    CalendarPickerIcon,
    ClockPickerIcon,
  },

  setup() {
    const {
      loading,
      categoryForm,
      categoryTierOptions,
      optionData,
      onUploadImage,
      onUploadImageSub,
      fetchcategoryDetail,
      createCategoryDetail,
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
    } = usePrivilegeCategoryInfo()

    return {
      loading,
      categoryForm,
      categoryTierOptions,
      optionData,
      onUploadImage,
      onUploadImageSub,
      fetchcategoryDetail,
      createCategoryDetail,
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style scoped>
@import '~@/assets/css/pages/tags/tags-info.css';
@import '~@/assets/css/pages/privilege/privilege-category-detail.css';
@import '~@/assets/css/override-styles/tag-dropdown.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import '~@/assets/css/pages/data-management.css';
</style>
